import { render, staticRenderFns } from "./ModalRequestConfirmEmail.vue?vue&type=template&id=12c1c304"
import script from "./ModalRequestConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ModalRequestConfirmEmail.vue?vue&type=script&lang=js"
import style0 from "./ModalRequestConfirmEmail.vue?vue&type=style&index=0&id=12c1c304&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports